var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarTodayBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3922_16002)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.833 1.9974H13.1663V1.33073C13.1663 0.964063 12.8663 0.664062 12.4997 0.664062C12.133 0.664062 11.833 0.964063 11.833 1.33073V1.9974H5.16634V1.33073C5.16634 0.964063 4.86634 0.664062 4.49967 0.664062C4.13301 0.664062 3.83301 0.964063 3.83301 1.33073V1.9974H3.16634C2.43301 1.9974 1.83301 2.5974 1.83301 3.33073V13.9974C1.83301 14.7307 2.43301 15.3307 3.16634 15.3307H13.833C14.5663 15.3307 15.1663 14.7307 15.1663 13.9974V3.33073C15.1663 2.5974 14.5663 1.9974 13.833 1.9974ZM13.1663 13.9974H3.83301C3.46634 13.9974 3.16634 13.6974 3.16634 13.3307V5.33073H13.833V13.3307C13.833 13.6974 13.533 13.9974 13.1663 13.9974Z",
    fill: "#009EF7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3922_16002"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarTodayBlue);
export default __webpack_public_path__ + "static/media/calendar-today-blue.0177880b4cc125d6f349122bc00f7397.svg";
export { ForwardRef as ReactComponent };